export const TASK_SOURCE_ROLES = [
  { id: "unspecified", label: "No label" },
  { id: "current_behavior", label: "Current behavior" },
  { id: "desired_design", label: "Desired design" },
  { id: "error_state", label: "Error state" },
  { id: "mobile_view", label: "Mobile view" },
  { id: "example_only", label: "Example only" },
  { id: "supporting_context", label: "Supporting context" },
];

export const TASK_SOURCE_ACCEPT = "image/png,image/jpeg,image/webp";

export function taskSourceStatusLabel(state) {
  switch (state) {
    case "received":
    case "validating":
    case "scanning":
      return "Checking the file";
    case "analyzing":
      return "Reviewing the screenshot";
    case "ready":
      return "Reviewed";
    case "partial":
      return "Reviewed with gaps";
    case "failed":
      return "Could not review";
    case "unsupported":
      return "Use PNG, JPEG, or WebP";
    case "quarantined":
      return "Blocked for safety";
    default:
      return "Working";
  }
}

export function isTaskSourceBusy(state) {
  return ["received", "validating", "scanning", "analyzing"].includes(state);
}

export function taskSourceClaimText(claim) {
  if (claim == null) return "";
  if (typeof claim === "string") return claim;
  if (typeof claim.text === "string") return claim.text;
  if (typeof claim.summary === "string") return claim.summary;
  return "";
}

export function canStartTaskFromSources(text, artifacts = []) {
  if (String(text || "").trim()) return true;
  return artifacts.some((item) => item.processingState === "ready" || item.processingState === "partial");
}
